export const RANGE_OPTIONS = [
    { value: 'ALL', label: 'Łącznie' },
    { value: 'YEAR', label: 'Rocznie' },
    { value: 'RANGE', label: 'Zakres dat' },
];
export const EVENT_DETAIL_TIME_OPTIONS = [
    { value: 'WEEK', label: 'Ostatnie 7 dni' },
    { value: 'ALL', label: 'Całość' },
];

export const YEAR_OPTIONS = ['2024', '2025', '2026'].map((year) => ({
    value: year,
    label: year,
}));

export const MONTH_OPTIONS = [
    { value: '01', label: 'Styczeń' },
    { value: '02', label: 'Luty' },
    { value: '03', label: 'Marzec' },
    { value: '04', label: 'Kwiecień' },
    { value: '05', label: 'Maj' },
    { value: '06', label: 'Czerwiec' },
    { value: '07', label: 'Lipiec' },
    { value: '08', label: 'Sierpień' },
    { value: '09', label: 'Wrzesień' },
    { value: '10', label: 'Październik' },
    { value: '11', label: 'Listopad' },
    { value: '12', label: 'Grudzień' },
];

export const LABELS = {
    ALL: ['2022', '2023', '2024', '2025', '2026'],
    YEAR: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
    MONTH: Array.from({ length: 31 }, (_, index) => `${index + 1}`),
    WEEK: ['pon', 'wt', 'śr', 'czw', 'pt', 'sob', 'nd'],
};

export const EVENT_DETAIL_TAB = 'Statystyki wydarzenia';
export const RANKING_LIST_LIMIT = 10;
export const ORGANIZER_NAME_FALLBACK = 'Brak organizatora';

export const AGE_BUCKETS = ['18–24', '25–29', '30–39', '40–49', '50+'];
export const GENDER_LABELS = {
    K: 'Kobiety',
    M: 'Mężczyźni',
    I: 'Inna',
};
export const USERS_GENDER_FILTERS = [
    { value: 'ALL', label: 'Wszyscy' },
    { value: 'K', label: 'Kobiety' },
    { value: 'M', label: 'Mężczyźni' },
    { value: 'I', label: 'Inna' },
];
export const GENDER_COLORS = {
    K: '#EE8F3B',
    M: '#7D959F',
    I: '#D5DADE',
};
export const EVENT_GENDER_CARD_COLORS = {
    K: '#EE8F3B',
    M: '#7D959F',
    I: '#169ACF',
};
export const EVENT_ACTIVITY_COLORS = {
    viewing: '#2F5F6D',
    packs: '#EE8F3B',
    favorites: '#00868B',
};
export const EVENT_FILTER_BUTTONS = [
    { value: 'ALL', label: 'Wszyscy', color: '#2F5F6D' },
    { value: 'M', label: 'Mężczyźni', color: '#EE8F3B' },
    { value: 'K', label: 'Kobiety', color: '#00868B' },
    { value: 'I', label: 'Inni', color: '#169ACF' },
];
export const EVENT_INFO_CONTENT = {
    viewing: {
        title: 'Wyświetlenia',
        lines: [
            'Wykres pokazuje łączną liczbę wyświetleń Twojego wydarzenia oraz profil użytkowników, którzy je wyświetlili.',
        ],
    },
    packs: {
        title: 'Użytkownicy',
        lines: [
            'Wykres pokazuje łączną liczbę oraz profil użytkowników, którzy utworzyli lub dołączyli do paczek związanych z Twoim wydarzeniem.',
        ],
    },
    newVsReturning: {
        title: 'Użytkownicy',
        lines: [
            'Nowy użytkownik - osoba, która po raz pierwszy utworzyła lub dołączyła do paczki pod którymkolwiek z Twoich wydarzeń.',
            'Powracający użytkownik - osoba, która już wcześniej brała udział w paczkach pod Twoimi wydarzeniami.',
        ],
    },
};
